import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  Renderer2,
  SimpleChanges,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { Subject } from 'rxjs';

import { FileService } from 'src/app/core/services/file.service';
import { AppInputSize } from 'src/app/core/types/app-input-size.type';

@Component({
  selector: 'app-file-uploader',
  templateUrl: './file-uploader.component.html',
  standalone: false,
})
export class FileUploaderComponent implements OnInit {
  //#region properties

  @Input('fileId') input_fileId: string = 'fileUpload';
  @Input('label') input_label: string = 'common.selectFile';
  @Input('placeholder') input_placeholder: string = 'common.selectFile';
  // @Input('form') input_form: FormGroup;
  @Input('progress') input_progress: number;
  // @Input('groupName') input_formGroupName: string;
  @Input('hasForm') input_hasForm: boolean = true;
  @Input('isShowRequiredStar') input_isShowRequiredStar: boolean = true;
  @Input('controlName') input_formControlName: FormControl | any;
  @Input('isDisabled') input_isDisabled: boolean = false;
  @Input() loading: boolean = false;
  @Input('acceptFile') input_fileAccept: string = ''; //.txt,.xls,.xlsx,.csv
  @Input('maxFileSize') input_maxFileSize: number = 1; //mb

  @Input('sizeType') input_sizeType: AppInputSize = 'kb';

  file: any;
  fileTypes: string[];
  isEmptyFile: boolean = true;
  //option value
  @Output('file') output_value = new EventEmitter<any>();
  @Output('onClearFile') output_onClearFile = new EventEmitter<boolean>();

  protected onDestroy$ = new Subject<void>();

  //#endregion

  constructor(
    protected fileService: FileService,
    protected elementRef: ElementRef,
    protected renderer: Renderer2
  ) {}

  ngOnInit() {
    this.getFileTypes();
  }

  getFileTypes() {
    // get fileTypes as Array
    if (this.input_fileAccept) {
      let newArray: string[] = this.input_fileAccept.split(',');
      let newArray2 = newArray.toString().replace('.', '').split(',.');

      this.fileTypes = newArray2;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['input_fileAccept']) this.getFileTypes();
  }

  onCheckFile(event) {
    if (!event) {
      this.output_value.emit(null);
      return;
    }

    const file = event?.target?.files[0];

    if (!file) return;

    if (this.fileTypes)
      if (!this.checkFileType(file, this.fileTypes)) {
        this.clearFile();
        return;
      }

    if (!this.checkFileSize(file, this.input_maxFileSize)) {
      this.clearFile();
      return;
    }

    this.file = file;
    this.isEmptyFile = false;
    this.output_value.emit(file);
  }

  onSelectFile() {
    const selectFileIconElement =
      this.elementRef.nativeElement.querySelector('.select-file-icon');
    if (selectFileIconElement) selectFileIconElement.click();
  }

  clearFile() {
    const fileInput = (
      this.elementRef.nativeElement as HTMLElement
    ).querySelector('input');
    if (!fileInput) return;
    this.renderer.setProperty(fileInput as HTMLInputElement, 'value', '');

    // (fileInput as HTMLInputElement).value = '';
    this.file = '';
    this.isEmptyFile = true;
    this.output_value.emit(null);
    this.output_onClearFile.emit(true);
  }

  checkFileType(file, fileTypes): boolean {
    if (this.fileService.checkFileType(file, fileTypes)) return true;
    return false;
  }

  checkFileSize(file, maxSize): boolean {
    switch (this.input_sizeType) {
      case 'mb':
        if (this.fileService.checkFileSizeWithMb(file, maxSize)) return true;
        break;
      case 'kb':
        if (this.fileService.checkFileSizeWithKB(file, maxSize)) return true;
        break;
      case 'gb':
        if (this.fileService.checkFileSizeWithGB(file, maxSize)) return true;
        break;
      default:
        break;
    }

    return false;
  }
}
